<button mat-raised-button color="primary" class="col-12"
        bsDaterangepicker [bsConfig]="bsConfig" (bsValueChange)="setDate($event)" placement="placement($event)">
  {{selectedDate[0] | date}} - {{selectedDate[1] | date}}
  <mat-icon aria-hidden="false" aria-label="Calendar icon">today</mat-icon>
</button>
